<template>
  <div id="home">

    <div class="scrollView"  @scroll="elementScroll($event)">

      <div class="top-banner">
        <img src="../assets/sntv-icon.png" class="top-banner-img">
        <div>「推荐栏目」</div>
      </div>

      <div class="scroll-x lanmu_nav">
        <div class="scroll-x-item " :class="{active:item.nav_id == nav_id}" @click="setNavId(item.nav_id)" v-for="item in nav_top">{{item.nav_name}}</div>
      </div>

      <div class="lanmu_item_videos_item_warp">
        <div class="lanmu_item_videos_item " :style="{width:item_width+'px'}" v-for="item in list" @click="openzhuanlan_content(item)" >
          <img v-lazy="item.thumb +'?x-oss-process=image/resize,m_fill,h_680,w_480'" class="lanmu_item_videos_item_poster" :style="{width:item_width+'px',height:item_height+'px'}">
          <div class="lanmu_item_videos_item_b ">
            <div class="lanmu_item_title text-overflow-one">{{item.movie_name}}</div>
            <div class="lanmu_item_desc text-overflow">{{item.movie_desc}}</div>
          </div>
        </div>

      </div>

      <!-- loading-->
      <div v-if="showloading && !loadend" class="bottom-loading">
        <van-loading size="24px">加载中...</van-loading>
      </div>

    </div>


    <div class="c-loading" v-if="loading">
      <div class="c-loading-c">
        <img src="../assets/loading.svg">
        <div>加载中...</div>
      </div>

    </div>

  </div>
</template>
<style >

  header{ display: flex; justify-content: space-between; align-items: center; height: 60px; font-size: 16px; color: #222222;text-align: center;
     padding-right: 15px; box-sizing: border-box; border-bottom: 0.5px solid #eaeaea;
  }
  .back img{ height: 18px; display: block}


  .header-start,.header-end{ display: flex;align-items: center; width: 80px;}

  .header-end{ justify-content: flex-end;height: 20px}
  #home{ height: 100vh;position: fixed; width: 100%; left: 0; top:0; display: flex; flex-direction: column}


  .header{ position: fixed; width: 100%; left: 0; top:0; background-color: #fff;z-index: 1000;}
  .bg_img{ width: 100%}
  header .text-overflow-one{width: 60%;text-align: center;}

  .labels_warp{ width: 100%; height: 40px; padding: 0 15px;border-bottom: 0.3px solid #eaeaea;}
  .labels_cont{ width: 100% ;display: flex}
  .labels_item{ height: 40px; line-height: 40px; padding: 0 15px; font-size: 16px; color: #3e3e3e}
  .labels_item.active{color: red}
  .back2{ position: fixed; left:0; top:0; z-index: 1; height: 75px;  display: flex;  align-items: center }
  .back2 .back2-warp{ display: flex; justify-content: center; align-items: center;width: 50px; height: 50px;}
  .back2  img{height: 18px; display: block}
  .back2-warp div{display: flex; justify-content: center; align-items: center; width: 30px; height: 30px; border-radius: 50%; }
  .noimghead{ width: 100%; height: 60px}


</style>
<style scoped>
#home{
  background-color: #860000; background-image: url("../assets/zhuanlan_bg.jpg"); background-size: 100% auto; background-repeat: no-repeat; background-position: top center; color: #fff;
}
.top-banner{ padding-top: 30px; position: relative; }
.top-banner div{ position: absolute; left: 15px; bottom: 15px; font-size: 16px}
.top-banner-img{ width: 100%}
.lanmu_nav{ width: 100%; height: 30px; margin-bottom: 15px}
.scroll-x-item{ padding: 0 5px; margin-left: 10px; font-size: 16px; line-height: 30px; position: relative}
.scroll-x-item:last-child{ margin-right: 10px}
.scroll-x-item.active{color: #ffd17c}
.scroll-x-item.active:after{ position: absolute; width: 20px; height: 1px; background-color:#ffd17c; content: " "; left: 50%; bottom:0; transform: translateX(-50%) }

.lanmu_item_videos_item_warp{ display: flex; flex-wrap: wrap; justify-content: space-between; padding:10px 15px}
.lanmu_item_videos_item{ width: 32%; margin-bottom: 10px}

.lanmu_item_videos_item:after {
  content: "";
  width: 33.3%;
  height: 50px;
}

.lanmu_item_videos_item_poster{ width: 100%; height: 220px; object-fit: cover;border-radius: 6px;}
.lanmu_item_videos_item_b{ padding: 2px 0; height: 55px}
.lanmu_item_title{ font-size: 14px; font-weight: bold; line-height: 20px; height: 20px;overflow: hidden;word-break: break-all; width: 100%}
.lanmu_item_desc{ font-size: 12px;  line-height: 16px;height: 32px; color: #d4b8b8 }
.lanmu_item{ margin-bottom: 20px; padding-bottom: 20px; border-bottom: 1px solid #fff}
</style>
<script>
  import { ImagePreview } from 'vant';
// @ is an alias to /src






  import request from "../utils/request";
  import utils from "../utils";

export default {
  name: 'videoProgram',
  components: {

  },
  data: function(){
    return {
      show_no_internet: false,

      hide: false,
      list: [],
      page: 1,
      showloading: true,
      loadend: false,
      scrolltop: 0,
      title:"推荐栏目",
      nav_top:[],
      nav_id:4,
      item_width:300,
      item_height:400,

      header_opactiy:1,
      loading:true,

    }
  },

  created: function created() {
    this.show = true;
    document.title = '看度时政-推荐栏目';
    document.getElementById("home")
    this.getdata();
  },
  mounted() {
    this.item_width = parseInt((document.getElementById("home").offsetWidth-30)/3.2);
    this.item_height = ((document.getElementById("home").offsetWidth-30)/3.2)/(3/4)

    document.querySelector(".toplink").style.display = 'none';
  },
  watch: {
    $route: function (newVal,oldVal) {
      if(oldVal.name===newVal.name){
        this.list = [];
        this.page = 1;
        setTimeout(()=>{
          this.getdata();
        },10)
      }
    }
  },
  methods: {


    setdefaultImg: function setdefaultImg(event) {
      var el = event.currentTarget;
      el.style.opacity = 0;
    },
    //TextAre换行符
    TextAreaText2Html: function TextAreaText2Html(str) {
      if (!str) {
        return "";
      }
      var reg = /\n/gim;
      var reg1 = /\r/gim;
      var reg3 = /\n\r/gim;
      var reg4 = /\s/gim;
      str = str.replace(reg3, "<br/>");
      str = str.replace(reg, "<br/>");
      str = str.replace(reg1, "<br/>");
      str = str.replace(reg4, "&nbsp;");

      return str;
    },
    setNavId:function(nav_id){
      this.nav_id = nav_id;
      this.showloading = true;
      this.list = [];
      this.page = 1;
      this.getdata();
    },
    //视频栏目详情
    openzhuanlan_content:function(item){



      //0 视频 1 栏目
      if(item.type===1){
        this.$router.push({name: "videoProgramContent",params:{id:item.movie_id}})
      }else{
        this.$router.push({name: "defaultVideoContent",params:{id:item.movie_id}})
      }
    },
    //获取数据
    getdata: function getdata() {
      var _this = this;




      var page = this.page;
      this.page ++;
      var requsetParams = {
        page:page,
        nav_id:this.nav_id
      }
      request.lanmu_list( requsetParams,  (res, err)=> {
        // console.log(JSON.stringify(res))
        _this.showloading = false
        _this.loading = false;
        // if(!res.banner_thumb){
        //   _this.header_opactiy =1
        // }else{
        //   _this.specsub_imgthumb = res.banner_thumb
        // }
        if (err) {
          _this.show_no_internet = true;
          _this.showloading = false;
          return;
        }



        if (res && res.code == 200) {
          //没有数据
          if( res.data.nav_top && res.data.nav_top.length>0){
            this.nav_top = res.data.nav_top
          }
          if (res.data.length === 0) {
            this.loadend = true;
            this.showloading = false;
            return;
          }else if(res.data.length<10){
            this.loadend = true;
            this.showloading = false;
          }




          // var list = _this.list.concat(res.data);
          //
          // _this.list = utils.arrayDelRepeat(list, 'art_id');
          // _this.page++;

          if(!this.list){
            this.list = []
          }

          var list = this.list.concat(res.data.column_list);
          this.list = utils.arrayDelRepeat(list, 'movie_id');


          if(res){
            request.getWeixinShanre(location.href,(s_res)=>{
              let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
              let shareconfig = {appId,timestamp,nonceStr,signature};
              if(utils.is_weixin()){
                if(res.data){
                  let sharedata = {
                    title:"神鸟TV",
                    desc:"神鸟TV | 精品视频的聚集地",
                    link:location.href,
                    imgUrl:thumb
                  };
                  utils.setWeiXinShare(sharedata,shareconfig,false)
                }

              }
            });
          }
          if(res.desc && res.desc !=="求证新闻真相"){
            _this.desc = _this.TextAreaText2Html(res.desc)
            // _this.desc = res.desc
          }

        }
      });
    },
    elementScroll: function elementScroll(e) {
      var _this2 = this;

      this.scrolltop = e.target.scrollTop; //滚动到了底部

      if(this.specsub_imgthumb){
        var opactiy = e.target.scrollTop/100;
        if(opactiy<0){
          opactiy = 0
        }else if(opactiy>1){
          opactiy = 1
        }
        this.header_opactiy = opactiy;
      }
      if (this.scrollbottom) {
        var topheight = e.target.offsetHeight + e.target.scrollTop;

        if (topheight + 30 >= e.target.scrollHeight && this.lastscroll < e.target.scrollTop) {
          if (this.scrollTopTimeOut) {
            clearTimeout(this.scrollTopTimeOut);
            this.scrollTopTimeOut = false;
          }

          this.scrollTopTimeOut = setTimeout(function () {
            _this2.scrollbottom();
          }, 300);
        }

        this.lastscroll = e.target.scrollTop;
      }
    },
    scrollbottom: function scrollbottom() {
      this.getdata();
    }
  }
}
</script>
